import { render, staticRenderFns } from "./PM10RecordList.vue?vue&type=template&id=05399e03&scoped=true&"
import script from "./PM10RecordList.vue?vue&type=script&lang=js&"
export * from "./PM10RecordList.vue?vue&type=script&lang=js&"
import style0 from "./PM10RecordList.vue?vue&type=style&index=0&id=05399e03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05399e03",
  null
  
)

export default component.exports